import { NavLink } from 'react-router-dom';
import { cn } from '@mlm/ui/lib/cn';

/**
 * Sub-navigation for the SHOP side, which is the MLM business: buying, what you
 * bought, your money and your network. Learn is a separate top-level tab and is
 * deliberately not in here.
 */
const ITEMS = [
  { to: '/shop', label: 'Store', end: true },
  { to: '/shop/orders', label: 'Orders', end: false },
  { to: '/wallet', label: 'Wallet', end: false },
  { to: '/network', label: 'Network', end: false },
  { to: '/vault', label: 'Codes', end: false },
] as const;

export function ShopNav() {
  return (
    <nav aria-label="Shop" className="border-b border-border px-5">
      <ul className="flex gap-6">
        {ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'inline-flex min-h-11 items-center border-b-2 font-mono text-[0.62rem] uppercase tracking-[0.14em] transition-colors',
                  isActive
                    ? 'border-verde text-ink'
                    : 'border-transparent text-sage-deep hover:text-ink',
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
